import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "dashboardview.icomingbookingscard.title",
    defaultMessage: "Incoming bookings",
    description: "heading for incoming bookings card",
  },
});
